import { PickupData } from "@redotech/redo-model/draft-return/draft-return";
import { pickupLocationOptions } from "@redotech/redo-model/return-flow";
import { getDateString } from "@redotech/redo-web/date-utils";
import { Flex } from "@redotech/redo-web/flex";
import PickupTruckIcon from "@redotech/redo-web/icon-old/pickup-truck.svg";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";
import { ShipmentMethodCard } from "./shipment-method-card";

export const PickupCard = memo(function PickupCard({
  pickup,
}: {
  pickup: PickupData;
}) {
  const icon = useMemo(
    () => (
      <Flex height="full">
        <PickupTruckIcon />
      </Flex>
    ),
    [],
  );
  const title = useMemo(
    () => <Text fontWeight="bold">Package pickup is added!</Text>,
    [],
  );
  const description = useMemo(
    () => (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text>
          Your package will be picked up from the pickup address on{" "}
          {getDateString(Temporal.PlainDate.from(pickup.pickupDate))}{" "}
          {
            pickupLocationOptions.get(pickup.pickupLocation.packageLocation)
              ?.detail
          }
          .
        </Text>
        <Text>
          You will need to pack up your return and print the shipping label.
        </Text>
      </Flex>
    ),
    [pickup],
  );

  if (!pickup?.pickupLocation) {
    return null;
  }

  return (
    <ShipmentMethodCard description={description} icon={icon} title={title} />
  );
});
